var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { ReactElementFactory } from "../../element-factory";
import { SurveyElementBase } from "../../reactquestion_element";
import { attachKey2click } from "../../reactSurvey";
var ListItem = /** @class */ (function (_super) {
    __extends(ListItem, _super);
    function ListItem(props) {
        var _this = _super.call(this, props) || this;
        _this.handleKeydown = function (event) {
            _this.model.onKeyDown(event);
        };
        _this.elementRef = React.createRef();
        return _this;
    }
    Object.defineProperty(ListItem.prototype, "model", {
        get: function () {
            return this.props.model;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ListItem.prototype, "item", {
        get: function () {
            return this.props.item;
        },
        enumerable: false,
        configurable: true
    });
    ListItem.prototype.getStateElement = function () {
        return this.item;
    };
    ListItem.prototype.render = function () {
        var _this = this;
        if (!this.item)
            return null;
        var className = this.model.getItemClass(this.item);
        var itemContent = this.item.component || this.model.itemComponent;
        var newElement = ReactElementFactory.Instance.createElement(itemContent, { item: this.item, key: this.item.id, model: this.model });
        var contentWrap = React.createElement("div", { ref: this.elementRef, style: this.model.getItemStyle(this.item), className: this.model.cssClasses.itemBody, title: this.item.getTooltip(), onMouseOver: function (event) { _this.model.onItemHover(_this.item); }, onMouseLeave: function (event) { _this.model.onItemLeave(_this.item); } }, newElement);
        var separator = this.item.needSeparator ? React.createElement("div", { className: this.model.cssClasses.itemSeparator }) : null;
        var isVisible = this.model.isItemVisible(this.item);
        var style = {
            display: isVisible ? null : "none"
        };
        return attachKey2click(React.createElement("li", { className: className, role: this.model.listItemRole, style: style, id: this.item.elementId, "aria-selected": this.model.getA11yItemAriaSelected(this.item), "aria-checked": this.model.getA11yItemAriaChecked(this.item), onClick: function (event) {
                _this.model.onItemClick(_this.item);
                event.stopPropagation();
            }, onPointerDown: function (event) { return _this.model.onPointerDown(event, _this.item); } },
            separator,
            contentWrap), this.item);
    };
    ListItem.prototype.componentDidMount = function () {
        var _a;
        _super.prototype.componentDidMount.call(this);
        this.model.onItemRended(this.item, (_a = this.elementRef) === null || _a === void 0 ? void 0 : _a.current);
    };
    return ListItem;
}(SurveyElementBase));
export { ListItem };
ReactElementFactory.Instance.registerElement("sv-list-item", function (props) {
    return React.createElement(ListItem, props);
});
